import type { ReactNode } from 'react';

import './ChoiceGrid.scss';

/** Пропсы сетки карточек выбора ChoiceGrid. */
export interface ChoiceGridProps {
  /** Число колонок на десктопе (по умолчанию 3). Адаптив: 6 → 4 (<1050px);
   *  2 и 3 → 1, 6 → 3 (<768px). 'auto' — сколько влезет (от 110px), плитки
   *  сами переносятся: для коротких наборов вроде селекторов-плиток. */
  columns?: 2 | 3 | 6 | 'auto';
  className?: string;
  children: ReactNode;
}

/** Сетка для ChoiceCard: равные колонки без переполнения, адаптив зашит. */
const ChoiceGrid = ({ columns = 3, className, children }: ChoiceGridProps) => (
  <div
    className={ `choice-grid${ columns !== 3 ? ` choice-grid-${ columns }` : '' }${ className ? ` ${ className }` : '' }` }
  >
    { children }
  </div>
);

export default ChoiceGrid;
